export default __webpack_public_path__ + "static/media/magnifier.19b67ced.svg";